import React from 'react'
import { Helmet } from "react-helmet-async"; // ✅ ADD THIS
import Banner from '../Components/Banner'
import pattern from '../Assets/aboutbanner pattern.png';
import Breadcrumb from './../Components/Breadcrumb';
import ContactSection from './../Components/Contact/ContactCOnSection';
import { motion } from "framer-motion";

const Contact = () => {

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  // ✅ LOCAL BUSINESS SCHEMA (VERY IMPORTANT)
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Nova EduBridge",
    "url": "https://novaedubridge.com/",
    "telephone": "+91-9902043004",
    "email": "info@novaedubridge.com",
    "description": "Nova EduBridge is a leading study abroad consultancy in Bangalore offering admissions, visa guidance, and test preparation services.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.121, 1st Floor, Eshwar Plaza, 4th Main Road, 1st Phase, 1st Stage, Manjunatha Nagar, West of Cord Road",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560010",
      "addressCountry": "IN"
    },
    "areaServed": "Bangalore",
    "openingHours": "Mo-Sa 10:00-19:00",
    "sameAs": [
      "https://www.instagram.com/",
      "https://www.facebook.com/"
    ]
  };

  return (
    <>
      {/* ✅ SCHEMA */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div>
        {/* Banner */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <Banner
            className='position-relative'
            subtitle="Contact Us - Nova EduBridge"
             title="Contact Study Abroad Consultants in Bangalore"
            buttonText="Our Services"
            buttonLink="/services"
            backgroundImage="/images/about-banner.png"
          />
          <div className='position-absolute pattern'>
            <img src={pattern} alt='pattern' />
          </div>
        </motion.div>

        {/* Breadcrumb */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <Breadcrumb/>
        </motion.div>

        {/* Contact Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <ContactSection/>
        </motion.div>
      </div>
    </>
  )
}

export default Contact;
